import { Component } from '@angular/core';
import { AttachmentDto } from '../../models/data.model';
import { CommonService } from '../../services/common.service';
import { MimetypeService } from '../../services/mimetype.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-equaltec-modal',
  templateUrl: './EqualtecModal.component.html',
  styleUrls: ['./EqualtecModal.component.css']
})
export class EqualtecModal {
  isOpen = false;
  items: AttachmentDto[] = [];

  constructor(
    private modalService: ModalService,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService
  ) {
    this.modalService.data.subscribe(data => {
      this.items = data;
      this.items.forEach(all => {
        const splitAll = all.nomeFile.split('.');
        all.estensione = splitAll[splitAll.length - 1];

      })

    });



    this.modalService.isOpen.subscribe(value => {
      console.log('Modale isOpen:', value);
      this.isOpen = value;
    });
  }

  close() {
    this.modalService.close();
  }

  getArcadocAttach(item: AttachmentDto, download: boolean) {
    const iddocumento = this.modalService.idDocumento
    const url = 'api/rest/GetAttachment';
    const params = {
      params: {
        idAllegato: item.idAllegato,
        idDocument: iddocumento,
        fileName: item.nomeFile,
        download: download
      }
    };
    this.fileServer.getData(url, params, false).toPromise()
      .then(res => {
        const attachment: AttachmentDto = res as AttachmentDto;
        const fileName = attachment.nomeFile;
        const ext = fileName.split('.').pop() || '';
        const downloadLink = document.createElement("a");
        this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext))
          .then(b => {
            const blob = b as Blob
            const url = URL.createObjectURL(blob);
            if (download) {
              downloadLink.href = url;
              downloadLink.download = fileName;
              downloadLink.click();
            } else {
              window.open(url, '_blank')
            }
          })
      });
  }

  dataURIToBlob = (dataURI: any, mimeString: string) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }

}
